import styled from 'styled-components';

// ✅ Usar sistema de temas - siguiendo patrón MainButton
export const TableContainer = styled.div`
  width: 100%;
  height: 22.3rem;
  overflow: auto;
  background-color: ${({ theme }) => theme.colors.greyVerySoft};
`;

export const Table = styled.table`
  width: 100%;
  text-align: left;
  font-size: ${({ theme }) => theme.fontSize.S};
`;

export const TableHeader = styled.thead`
  background: ${({ theme }) => theme.colors.greyDark};
  color: ${({ theme }) => theme.colors.white};
  position: sticky;
  top: 0;
  z-index: ${({ theme }) => theme.zIndex.sticky};
`;

export const TableHeaderCell = styled.th`
  padding: ${({ theme }) => theme.spacing.xxs} 0
    ${({ theme }) => theme.spacing.xxs} ${({ theme }) => theme.spacing.l};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;

  &:first-of-type {
    border-top-left-radius: ${({ theme }) => theme.borderRadius.md};
  }
  &:last-of-type {
    border-top-right-radius: ${({ theme }) => theme.borderRadius.md};
    padding: ${({ theme }) => theme.spacing.xxs}
      ${({ theme }) => theme.spacing.l};
  }
`;

export const TableBody = styled.tbody`
  background: ${({ theme }) => theme.colors.greyVerySoft};
  color: ${({ theme }) => theme.colors.black};
`;

export const TableRow = styled.tr`
  position: relative;
`;

export const TableCell = styled.td`
  padding: ${({ theme }) => theme.spacing.xxs} 0
    ${({ theme }) => theme.spacing.xxs} ${({ theme }) => theme.spacing.l};
  border-bottom: 0.1rem solid ${({ theme }) => theme.colors.greyLight};
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;

  &:last-of-type {
    padding: ${({ theme }) => theme.spacing.xxs}
      ${({ theme }) => theme.spacing.l};
    width: 0;
  }

  /* Permitir wrap en celdas de descripción */
  &[data-description='true'] {
    white-space: normal;
    word-wrap: break-word;
    max-width: 300px;
  }
`;

export const CategoryIndicator = styled.div<{ color?: string }>`
  width: 12px;
  height: 12px;
  border-radius: ${({ theme }) => theme.borderRadius.full};
  background-color: ${(props) => props.color || props.theme.colors.mediumGrey};
  flex-shrink: 0;
`;

export const ActionCell = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.s};
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) =>
    theme.spacing.xs}; // ✅ Más área clickeable usando spacing del tema
`;

export const RemoveIcon = styled.img`
  cursor: pointer; // ✅ Cursor pointer
  width: 20px; // ✅ Más grande (era 16px)
  height: 20px; // ✅ Más grande (era 16px)
  opacity: ${({ theme }) => theme.opacity.hover}; // ✅ Usar opacidad del tema
  transition: ${({ theme }) =>
    theme.transitions.fast}; // ✅ Usar transición del tema
  padding: 2px; // ✅ Área clickeable más grande

  &:hover {
    opacity: 1; // ✅ Solo cambio de opacidad al hover
  }
`;

export const EmptyState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.spacing.xl};
  background-color: ${({ theme }) => theme.colors.greyVerySoft};
  min-height: 19.2rem;
  width: 100%;
`;
